import { inject } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, tap } from 'rxjs/operators';

import { ChatStorageService } from '@lib/chat/services/chat-storage.service';
import { clearChatDraftByThread, clearChatDrafts, getChatDrafts, getChatDraftsSuccess, setChatDraft } from '@lib/chat/store/chat.actions';

export const getChatDraftsEffect = createEffect(
  () => {
    const actions$ = inject(Actions);
    const chatStorageService = inject(ChatStorageService);

    return actions$.pipe(
      ofType(getChatDrafts),
      map(() => {
        const chatDrafts = chatStorageService.getDraftsFromStorage();
        return getChatDraftsSuccess({ chatDrafts });
      })
    );
  },
  { functional: true }
);

export const setChatDraftEffect = createEffect(
  () => {
    const actions$ = inject(Actions);
    const chatStorageService = inject(ChatStorageService);

    return actions$.pipe(
      ofType(setChatDraft),
      tap(({ chatDraft }) => {
        chatStorageService.setSelectedDraftToStorage(chatDraft);
      })
    );
  },
  { functional: true, dispatch: false }
);

export const clearChatDraftByIdEffect = createEffect(
  () => {
    const actions$ = inject(Actions);
    const chatStorageService = inject(ChatStorageService);

    return actions$.pipe(
      ofType(clearChatDraftByThread),
      tap(({ chatDraft }) => {
        chatStorageService.clearSelectedDraftFromStorage(chatDraft.threadId);
      })
    );
  },
  { functional: true, dispatch: false }
);

export const clearChatDraftsEffect = createEffect(
  () => {
    const actions$ = inject(Actions);
    const chatStorageService = inject(ChatStorageService);

    return actions$.pipe(
      ofType(clearChatDrafts),
      tap(() => {
        chatStorageService.clearDraftsFromStorage();
      })
    );
  },
  { functional: true, dispatch: false }
);
